import Router from "next/router";

const restart = () => Router.reload(window.location.pathname);

export default restart;
